module.exports = __webpack_public_path__ + "images/pit-boss-2fcb178e74f808f55749ab738513146b.png";